import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-south-farm-map',
  template: `
  <maphilight
    id="southMap"
    [config]="config">

    <img src="../images/SouthFarm.jpg"
      class="map"
      usemap="#SouthFarmArea"
      alt="Beltsville Agricultural Research Center South Farm"
      height="587"
      width="760"
      border="0"/>
    <map name="SouthFarmArea">
      <area (click)="selectSite.emit('BARC 1')"
        alt="BARC 1"
        shape="rect"
        coords="152,441,230,464">
      <area (click)="selectSite.emit('BARC 2')"
        alt="BARC 2"
        shape="rect"
        coords="60,323,129,345">
      <area (click)="selectSite.emit('BARC 17')"
        alt="BARC 17"
        shape="rect"
        coords="587,445,666,470">
    </map>
  </maphilight>
  `
})
export class SouthFarmMapComponent {
  @Input() config: any;
  @Output() selectSite: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/south-farm-map.ts